<template>
  <div :class="$style.root" :style="rootStyle">
    <slot :symbolClass="$style.symbol" :maskClass="$style.mask">
      <template v-for="symbol in symbols">
        <span v-if="!shouldMask(symbol)" :class="$style.symbol">{{ symbol.symbol }}</span>
        <span v-else :class="$style.mask"></span>
      </template>
    </slot>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
    },
    symbols: {
      type: Array,
    },
    masks: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    rootStyle () {
      return {
        'background-color': this.bgColor,
      }
    },
  },
  methods: {
    shouldMask (symbol) {
      return this.masks.find(({ word }) => word.word == symbol.symbol)
    },
  },
}
</script>

<style lang="scss" module>
$fontSize: 5.5rem;

.root {
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply mx-auto;
  @apply py-4;
  @apply leading-none;
  font-size: $fontSize;
  width: 500px;
  min-height: 120px;
}

.symbol,
.mask {
  @apply mx-1;
}

.symbol {
  //
}

.mask {
  @apply inline-block;
  height: $fontSize;
  width: $fontSize;
  border-bottom: 4px solid black;
}
</style>
